var LoggedModule = /** @class */ (function () {
    function LoggedModule() {
    }
    return LoggedModule;
}());
export { LoggedModule };
